module.exports = __webpack_public_path__ + "img/darkblue-pin.48907162.png";